import {
    Box,
    Button,
    Img,
    Input,
    InputGroup,
    InputLeftAddon,
    InputLeftElement,
    Select,
    Stack,
    Text,
    Textarea,
    useColorModeValue,
  } from "@chakra-ui/react";
  import { useRef, useState } from "react";
  import { BsFillCameraFill } from "react-icons/bs";
  import { useLocation, useNavigate } from "react-router-dom";
  import { getUserProfile } from "../../context/getUserProfile";
  import { useGetState } from "../../context/useGetState";
  import { createGroups, removeGroupMember } from "./tradingGroup/service";
  import axios from "axios";
  import { errorNotifier, successNotifier } from "../..";
  import http, { AUTH_ROUTES } from "../../service/api";
  import { useEffect } from "react";
  import AddMembersModal from "./tradingGroup/AddMembersModal";
  import RemoveMembersModal from "./tradingGroup/RemoveMembersModal";
  import ChangeGroupRoleModal from "./tradingGroup/ChangeGroupRoleModal";


  const fakeOtherUsersData = [
    {
      id: 1,
      name: "John Doe",
      amount: "2000",
      created_at: "2023-07-08T15:02:11.000000Z",
      updated_at: "2023-07-08T15:02:11.000000Z",
    },
    {
      id: 2,
      name: "Aaron Brian",
      amount: "1000",
      created_at: "2023-07-09T15:02:11.000000Z",
      updated_at: "2023-07-09T15:02:11.000000Z",
    },
    {
      id: 3,
      name: "Maximus Solomon Diame",
      amount: "25000",
      created_at: "2023-08-07T15:02:11.000000Z",
      updated_at: "2023-08-07T15:02:11.000000Z",
    },
    {
      id: 4,
      name: "Flavour Namadi Sambo",
      amount: "2500",
      created_at: "2023-08-10T15:02:11.000000Z",
      updated_at: "2023-08-10T15:02:11.000000Z",
    },
    {
      id: 5,
      name: "Mike Adenuga Greg",
      amount: "9000",
      created_at: "2023-09-03T15:02:11.000000Z",
      updated_at: "2023-08-12T15:02:11.000000Z",
    },
    {
      id: 6,
      name: "Felix Ojemba Ayo",
      amount: "8000",
      created_at: "2023-09-01T15:02:11.000000Z",
      updated_at: "2023-08-15T15:02:11.000000Z",
    },
    
  ];
  
  function EditGroup() {
    const { state } = useGetState();
    const { userInfo } = state;
    const imgRef = useRef(null);
    
    const location = useLocation();
    let groupData = location.state?.groupData || undefined;
    //console.log('groupData: ', groupData);

    // useEffect(() => {
    //     if (groupData === undefined) {
    //         //get single-group api
    //        groupData = 
    //     }
    // }, []);

    const [img, setImg] = useState();
    const [imgDefault, setImgDefault] = useState(groupData?.picture);
    let $monthly_pay = `plans[0][price]`
    let $yearly_pay = `plans[1][price]`
    let $lifetime_pay = `plans[2][price]`

    const initValues = {
      group_name: groupData?.name,
      trial_period: "",
      price: "0",
      description: groupData?.description,
      category: groupData?.category?.id,
      group_access: groupData?.group_access,
      monthly_pay: groupData?.plans ? groupData?.plans[0].price : "",
      yearly_pay: groupData?.plans ? groupData?.plans[1].price : "",
      lifetime_pay: groupData?.plans ? groupData?.plans[2].price : "",
    };
    // Assign the key with dots as a string literal
    //initValues[$monthly_pay] = groupData?.plans ? groupData?.plans[0].price : "";

    const [formValues, setFormValues] = useState(initValues);
    const [previewImg, setPreviewImg] = useState(groupData?.picture);
    const [loading, setLoading] = useState(false);
    const [selectPlan, setSelectPlan] = useState(groupData?.type);
    const [nameExists, setNameExists] = useState(false);
    const [paidPlans, setPaidPlans] = useState([]);
    const [categories, setCategories] = useState([]);

    const [otherUsers, setOtherUsers] = useState([]);
    const [myMembers, setMyMembers] = useState([]);
    
    const [addMembersModalOpen, setAddMembersModalOpen] = useState(false);
    const [removeMembersModalOpen, setRemoveMembersModalOpen] = useState(false);
    const [changeMembersRoleModalOpen, setChangeMembersRoleModalOpen] = useState(false);
  
    const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
    const inputBgColor = useColorModeValue("#fff", "#081b2e");
    const textColor = useColorModeValue("#697C94", "#697C94");
    const navigate = useNavigate();
    const account_type = userInfo?.account_type;

    //console.log('myMembers: ', myMembers);
  
    // convert file to a base64 url
    const readURL = (file) => {
      return new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = (e) => res(e.target.result);
        reader.onerror = (e) => rej(e);
        reader.readAsDataURL(file);
      });
    };
  
    const inputStyles = {
      p: "25px",
      borderRadius: "10px",
      boxShadow: "3px 8px 13px 0px #8080800f",
      bg: inputBgColor,
      w: "100%",
      fontSize: ".9em",
      color: "#697C94",
    };
  
    useEffect(() => {
      async function fetchCategories() {
        const res = await http.get(AUTH_ROUTES.GET_GROUP_CATEGORIES);
        setCategories(res?.data);
      }
      fetchCategories();
    }, []);

    useEffect(() => {
      const updatedMyMembers = groupData?.members.filter((user) => user?.id !== userInfo?.id);
      setMyMembers(updatedMyMembers)
    }, [userInfo]);

    useEffect(() => {
      const fetchOtherUsersData = async () => {
        try {
          const othersRes = await http.get(AUTH_ROUTES.GET_GROUP_OTHER_USERS(groupData?.id));
          //console.log('others: ',othersRes?.data?.data);
          setOtherUsers(othersRes?.data?.data)
        } catch (error) {
          console.log('error: ', error);
        }

      }
      fetchOtherUsersData();
    }, [userInfo]);
    
    
    // Get the bearer token from sessionStorage
    const token = sessionStorage.getItem("#f8WEB#");
    // console.log('token: ', token);
  
    // Define headers with the bearer token
    const headers = {
      Authorization: `Bearer ${token}`,
      // Other headers if needed
    };
  
    //sameName logic
    let timer;
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormValues((prev) => ({ ...prev, [name]: value }));
  
      // Check if the change occurred in the "name" input field
      // if (name === "group_name") {
      //   // Clear the previous timer
      //   clearTimeout(timer);
  
      //   // Set a new timer to make the API call after a delay (e.g., 3000 milliseconds)
      //   timer = setTimeout(() => {
      //     // Make an Axios call to check if the group name exists
      //     axios.get(`https://f8.codester.dev/api/groups?search=${value}`, { headers })
      //       .then((response) => {
      //         // Check if the group name exists in the database based on the API response
      //         //const doesNameExist = response.data.some((group) => group.name === value);
      //         const doesNameExist = response?.data == true ? true : false;
      //         console.log("doesNameExist:", doesNameExist);
      //         setNameExists(doesNameExist);
      //       })
      //       .catch((error) => {});
      //   }, 3000); // Adjust the delay as needed
      // }
    };
    //end of same logic
  
    // Create a function to update the plans array based on changes in plan input fields
    const handlePaidPlanChange = (index, field, value) => {
      // Clone the current plans array to avoid mutating state directly
      const updatedPaidPlans = [...paidPlans];
  
      // Check if the plan object at the specified index exists, and create one if not
      if (!updatedPaidPlans[index]) {
        updatedPaidPlans[index] = { id: index + 1, price: 0 }; // Initialize with id and default price
      }
  
      // Update the specified field of the plan object
      updatedPaidPlans[index][field] = value;
  
      // Update the state with the updated plans array
      setPaidPlans(updatedPaidPlans);
    };
    //console.log('setPaidPlans: ', paidPlans.length);
  
    const handleSubmitForm = async () => {
      setLoading(true);
  
      const formData = new FormData();
      
      if (img) {
        formData.append("picture", img);
      }
      formData.append("name", formValues?.group_name);
      formData.append("description", formValues?.description);
      formData.append("group_category_id", formValues?.category);
      formData.append("group_access", formValues?.group_access);
      formData.append("type", selectPlan);
  
      //filter and append paid plans
      if (paidPlans.length > 0) {
        // Filter plans with non-zero prices
        const filteredPlans = paidPlans.filter((plan) => plan.price > 0);
        // Append filtered plans to the FormData
        filteredPlans.forEach((plan, index) => {
          formData.append(`plans[${index}][id]`, plan.id);
          formData.append(`plans[${index}][price]`, plan.price);
        });
      }
  
      const editGroupUrl = `https://f8.codester.dev/api/groups/${groupData?.id}/update`;
  
      try {
        // Make the Axios call with headers
        const response = await axios.post(editGroupUrl, formData, {
          headers,
        });
        
        if (response) {
          setFormValues(initValues);
          setLoading(false);
          successNotifier("Group updated successfully");
          navigate("/groups");
        }
  
        // ... Further processing of response
      } catch (error) {
        errorNotifier(error.response?.data?.message);
        console.error(error);
        setLoading(false);
      }
    };

    //Add members
    const handleAddMember = async (usersToAdd) => {
        
        //const res = await follow(userIdToRemove, setBtnLoading)
        //console.log('handleAddMember: ', '["1","2","3"]');
        
    };

    const handleAddSingleMember = async (userIdToRemove) => {
      try {
        let res = await http.get(AUTH_ROUTES.ADD_SINGLE_MEMBER_TO_GROUP(groupData?.id, userIdToRemove));
        setLoading(false);
        successNotifier(`Successfully Added Member To ${groupData?.name}`);
      } catch (error) {
        console.error("Error:", error);
      }
    }
    
    //Remove members
    const handleRemoveMember = async (usersToRemove) => {
    
      // Check if aboutData is not empty and contains the "about" field
      if (usersToRemove?.length > 0) {

        // Convert string IDs to numbers
        const usersToRemoveAsNumbers = usersToRemove.map((id) => parseInt(id, 10));

        //console.log('selectedUsersType: ', typeof(usersToRemove));
        const formData = new FormData();
        //formData.append("users[]", JSON.stringify(usersToRemove));
        formData.append("users[]", JSON.stringify(usersToRemove));
        
        try {
          let res = await http.post(AUTH_ROUTES.REMOVE_GROUP_MEMBERS(groupData?.id), formData);

          if (res) {
            //convert to string and filter, so that 'myMembers.id' matches usersToRemove ['1', '2']
            const updatedMembers = myMembers.filter((member) => !usersToRemove.includes(member?.id.toString()));
            setMyMembers(updatedMembers);
            setLoading(false);
            successNotifier(`Successfully Removed Members From ${groupData?.name}`);
          }
          
        } catch (error) {
          // Handle the error here, e.g., display an error message to the user
          console.error("Error updating about data:", error);
        }
      } else {
        // Handle the case where aboutData or aboutData.about is missing
        console.error("Missing 'selectedUsers' field in data");
      }
    };

    //Remove members
    const handleRemoveSingleMember = async (userIdToRemove) => {
    
      // Check if aboutData is not empty and contains the "about" field
      if (userIdToRemove) {
        console.log('userId: ', userIdToRemove)
        
        try {
          let res = await http.get(AUTH_ROUTES.REMOVE_GROUP_SINGLE_MEMBER(groupData?.id, userIdToRemove));

          if (res) {
            const updatedMembers = myMembers.filter((member) => member?.id !== userIdToRemove);
            setMyMembers(updatedMembers);
            setLoading(false);
            successNotifier(`Successfully Removed Members From ${groupData?.name}`);
          }
          
        } catch (error) {
          // Handle the error here, e.g., display an error message to the user
          console.error("Error updating about data:", error);
        }
      } else {
        // Handle the case where aboutData or aboutData.about is missing
        console.error("Missing 'selectedUsers' field in data");
      }
    };

    const handleDeleteMembers = async (usersToRemove) => {
      // Create a new array of members excluding the ones with IDs in 'usersToRemove'
      const updatedMembers = myMembers.filter((member) => !usersToRemove.includes(member?.user?.id));

      // Update 'myMembers' with the filtered array
      setMyMembers(updatedMembers);
    }

    //Remove members
    const handleChangeMemberRole = async (usersToChange) => {
        
        //const res = await follow(userIdToRemove, setBtnLoading)
        //console.log('handleAddMember: ', '["1","2","3"]');
        
    };
  
    return (
      <Stack direction={"row"} spacing="50px" pr="60px">
        <Stack flex="1" gap={"5px"}>
          {img || imgDefault ? (
            <Stack
              position={"relative"}
              maxW="200px"
              maxH="150px"
              objectFit={"cover"}
              w="200px"
              h="150px"
              cursor={"pointer"}
              
              onClick={() => imgRef.current.click()}
            >
              <Img
                borderRadius={"5px"}
                w="200px"
                h="150px"
                objectFit={"cover"}
                src={previewImg}
                alt="profile pic"
              />
              <BsFillCameraFill
                fontSize={"1.5em"}
                style={{
                  position: "absolute",
                  transform: "translate(90px, 50px)",
                }}
              />
            </Stack>
          ) : (
            <Stack
              w="200px"
              h="150px"
              borderRadius={"10px"}
              bg="#707070"
              py="20px"
              justifyContent={"center"}
              alignItems="center"
              color="#fff"
              cursor={"pointer"}
              onClick={() => imgRef.current.click()}
            >
              <BsFillCameraFill fontSize={"1.5em"} />
              <Text fontSize={".8em"} textAlign="center">
                Click to change
                <br /> Image
              </Text>
            </Stack>
          )}

          {/* Add Members  */}
          <Box display={"none"}>
            <Text 
            //size="xs"
            cursor={"pointer"}
            borderRadius={"5px"}
            textAlign={"center"}
            h="20px"
            w="100"
            bg="#1391e67d"
            _hover={{ background: "#1391e67d" }}
            color="#fff"
            boxShadow={"2px 2px 7px 0px #1391e67d"}
            // onClick={() => {
            //     navigate(`/groups/${slug}`, { state: { groupData: groupData } });
            // }}
            onClick={() => {
                //if ((otherUsers?.length > 0)) {
                    setAddMembersModalOpen(true);
                //}
            }}
            >Add Members</Text>
          </Box>

          {/* Remove Members  */}
          <Box display={"none"}>
            <Text 
            //size="xs"
            cursor={"pointer"}
            borderRadius={"5px"}
            textAlign={"center"}
            h="20px"
            w="100"
            bg="red"
            _hover={{ background: "red" }}
            color="#fff"
            boxShadow={"2px 2px 7px 0px red"}
            onClick={() => {
                if ((myMembers?.length > 0)) {
                    setRemoveMembersModalOpen(true);
                }
            }}
            >Remove Members</Text>
          </Box>

          {/* Change Members Role  */}
          <Box display={"none"}>
            <Text 
            //size="xs"
            cursor={"pointer"}
            borderRadius={"5px"}
            textAlign={"center"}
            h="20px"
            w="100"
            bg={containerBgColor}
            _hover={{ background: {containerBgColor} }}
            color="#fff"
            boxShadow={"2px 2px 7px 0px info"}
            onClick={() => {
                if ((myMembers?.length > 0)) {
                    setChangeMembersRoleModalOpen(true);
                }
            }}
            
            >Change Members Role</Text>
          </Box>

        </Stack>
        <Input
          type="file"
          ref={imgRef}
          accept="image/jpg, image/jpeg, image/png"
          display={"none"}
          onChange={async (e) => {
            setImg(e.target.files?.[0]);
            setPreviewImg(await readURL(e.target.files?.[0]));
          }}
        />

        {/* RHS */}
        <Stack
          flex="4"
          bg={containerBgColor}
          borderRadius={"15px"}
          p="20px"
          alignItems={"center"}
        >
          <Stack maxW="400px" w="350px" spacing={"25px"}>
            <Input
              placeholder="Group Name"
              type="text"
              name="group_name"
              //placeholder={formValues?.name}
              value={formValues?.group_name}
              onChange={handleChange}
              {...inputStyles}
            />
            {nameExists && (
              <p style={{ color: "red" }}>This group name already exists.</p>
            )}
  
            <Textarea
              rows={"4"}
              resize="none"
              placeholder="Describe Your Group..."
              name="description"
              value={formValues?.description}
              onChange={handleChange}
              {...inputStyles}
            />
            <style>{`
            .chakra-select__wrapper{
              background: ${inputBgColor};
              box-shadow: 3px 8px 13px 0px #8080800f;
              border-radius: 10px;
              padding: 10px;
            }
            `}</style>
            <Select
              default="forex"
              fontSize={".9em"}
              name="category"
              onChange={handleChange}
              _placeholder={{ color: "#f2f2f2" }}
              {...inputStyles}
              boxShadow="none"
              defaultValue={"default"}
            >
              <option value={groupData?.category?.id} color="#718096">
                {groupData?.category?.name}
              </option>
              {categories?.length > 0 &&
                categories.map((cat, index) => (
                  <option key={index} value={cat.id} style={{ color: "#718096" }}>
                    {cat.name}
                  </option>
                ))}
            </Select>

            <Select
              fontSize={".9em"}
              name="group_access"
              onChange={handleChange}
              _placeholder={{ color: "#f2f2f2" }}
              {...inputStyles}
              boxShadow="none"
              defaultValue={groupData?.group_access}
            >
              <option disabled value={groupData?.group_access} color="#718096">
                Select Privacy
              </option>
              <option value="public" style={{ color: "#718096" }}>
                  Public
              </option>
              <option value="private" style={{ color: "#718096" }}>
                  Private
              </option>
            </Select>

            <Stack direction={"row"} alignItems="center">
              <Text
                cursor={"pointer"}
                {...inputStyles}
                p="20px"
                {...(selectPlan === "free" ? inputStyles : {})}
                fontSize="initial"
                color={selectPlan === "free" && "#fff"}
                bg={selectPlan === "free" && "grey"}
                onClick={() => setSelectPlan("free")}
              >
                Free
              </Text>
              <Text
                {...inputStyles}
                p="20px"
                cursor="pointer"
                {...(selectPlan === "free" ? inputStyles : {})}
                fontSize="initial"
                color={selectPlan === "paid" && "#fff"}
                bg={selectPlan === "paid" && "grey"}
                onClick={() => setSelectPlan("paid")}
                fontWeight="medium"
              >
                Paid
              </Text>
            </Stack>
  
            {selectPlan === "paid" && (
              <>
                <Input
                  type={"text"}
                  placeholder="Free trial period(optional)"
                  disabled={selectPlan === "free"}
                  {...inputStyles}
                  name="trial_period"
                  value={formValues?.trial_period}
                  onChange={handleChange}
                />
  
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 23px 12px 23px",
                    borderRadius: "10px",
                    boxShadow: "3px 8px 13px 0px #8080800f",
                    backgroundColor: inputBgColor,
                    width: "100%", // Adjust the width as needed
                    fontSize: ".9em",
                    color: textColor,
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Input
                      placeholder={`$${formValues?.monthly_pay}`}
                      type="number"
                      variant="unstyled"
                      style={{
                        width: "100%",
                        padding: "0", // Remove default padding
                        border: "none", // Remove default border
                        outline: "none", // Remove default outline
                      }}
                      name="monthly_pay" 
                      //value={formValues?.monthly_pay}
                      onChange={(e) => {
                        const value = e.target.value;
                        handlePaidPlanChange(0, "price", value);
                      }}
                    />
                  </div>
                  <div>
                    {/* You can add an icon or caret here */}
                    Monthly plan(optional)
                  </div>
                </Box>
  
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 23px 12px 23px",
                    borderRadius: "10px",
                    boxShadow: "3px 8px 13px 0px #8080800f",
                    backgroundColor: inputBgColor,
                    width: "100%", // Adjust the width as needed
                    fontSize: ".9em",
                    color: textColor,
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Input
                      placeholder={`$${formValues?.yearly_pay}`}
                      type="number"
                      variant="unstyled"
                      style={{
                        width: "100%",
                        padding: "0", // Remove default padding
                        border: "none", // Remove default border
                        outline: "none", // Remove default outline
                      }}
                      name="yearly_pay"
                      //value={formValues?.yearly_pay}
                      onChange={(e) => {
                        const value = e.target.value;
                        handlePaidPlanChange(1, "price", value);
                      }}
                    />
                  </div>
                  <div>
                    {/* You can add an icon or caret here */}
                    Yearly plan(optional)
                  </div>
                </Box>
  
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 23px 12px 23px",
                    borderRadius: "10px",
                    boxShadow: "3px 8px 13px 0px #8080800f",
                    backgroundColor: inputBgColor,
                    width: "100%", // Adjust the width as needed
                    fontSize: ".9em",
                    color: textColor,
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Input
                      placeholder={`$${formValues?.lifetime_pay}`}
                      type="number"
                      variant="unstyled"
                      style={{
                        width: "100%",
                        padding: "0", // Remove default padding
                        border: "none", // Remove default border
                        outline: "none", // Remove default outline
                      }}
                      name="lifetime_pays"
                      //value={formValues?.lifetime_pay}
                      onChange={(e) => {
                        const value = e.target.value;
                        handlePaidPlanChange(2, "price", value);
                      }}
                    />
                  </div>
                  <div>
                    {/* You can add an icon or caret here */}
                    Lifetime (optional)
                  </div>
                </Box>
              </>
            )}
  
            <Button
              color="#fff"
              h="50px"
              w="250px"
              bg="#50BB69"
              _hover={{ background: "#50BB69" }}
              alignSelf={"center"}
              borderRadius="15px"
              isLoading={loading}
              onClick={handleSubmitForm}
            >
              Create Group
            </Button>
          </Stack>
        </Stack>
        {/* RHS */}

        <AddMembersModal
         authUserId={userInfo?.id} groupData={groupData} otherUsers={otherUsers} 
         handleAddMember={handleAddMember} handleAddSingleMember={handleAddSingleMember}
         isOpen={addMembersModalOpen} onClose={() => setAddMembersModalOpen(false)} 
        />
        <RemoveMembersModal
         authUserId={userInfo?.id} groupData={groupData} myMembers={myMembers}
         handleRemoveMember={handleRemoveMember} handleRemoveSingleMember={handleRemoveSingleMember}
         isOpen={removeMembersModalOpen} onClose={() => setRemoveMembersModalOpen(false)} 
        />
        <ChangeGroupRoleModal
         authUserId={userInfo?.id} groupData={groupData} myMembers={myMembers}
         handleChangeMemberRole={handleChangeMemberRole} isOpen={changeMembersRoleModalOpen} onClose={() => setChangeMembersRoleModalOpen(false)} 
        />
      </Stack>
    );
  }
  
  export default EditGroup;
  